"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefundTransactions = exports.getSaleTransaction = exports.processRefundTransaction = exports.processSaleTransaction = exports.getPaymentOptions = exports.getTerminals = exports.getTerminal = exports.getConfigs = void 0;
const shared_1 = require("@getgreenline/shared");
const payment_1 = require("../../models/blazepay/payment");
const refund_1 = require("../../models/blazepay/refund");
const enums_1 = require("../../models/blazepay/enums");
const convertFilterToParams = (filter) => {
    return Object.entries(filter || {}).reduce((acc, [key, value]) => {
        return { ...acc, [`filter[${key}]`]: value };
    }, {});
};
const getConfigs = async ({ merchantId }) => {
    const res = await shared_1.axios.get(`${shared_1.BLAZEPAY_API_URL}/api/v1/merchants/${merchantId}/configurations`);
    return res.data;
};
exports.getConfigs = getConfigs;
const getTerminal = async ({ merchantId, providerName, deviceId, }) => {
    const res = await shared_1.axios.get(shared_1.BLAZEPAY_API_URL +
        `/api/v1/merchants/${merchantId}/providers/${providerName}/terminals/pos/${deviceId}`);
    return res.data;
};
exports.getTerminal = getTerminal;
const getTerminals = async ({ merchantId, filter, }) => {
    const params = filter && convertFilterToParams({
        ...filter,
        terminalId: filter.deviceId,
        provider: filter.provider,
    });
    const res = await shared_1.axios.get(shared_1.BLAZEPAY_API_URL + `/api/v1/merchants/${merchantId}/terminals`, { params });
    return res.data;
};
exports.getTerminals = getTerminals;
const getPaymentOptions = async ({ merchantId, filter, }) => {
    const params = filter && convertFilterToParams(filter);
    const res = await shared_1.axios.get(`${shared_1.BLAZEPAY_API_URL}/api/v1/merchants/${merchantId}/payment-options`, { params });
    return res.data;
};
exports.getPaymentOptions = getPaymentOptions;
/**
 *
 * @description Idempotency-Key should be unique for each request and store it in the database for each transaction
 * @returns
 */
const processSaleTransaction = async ({ idempotencyKey, merchantId, providerName, payload: { deviceId, offlinePaymentId, transactionAmount, currentShiftId, customerId }, }) => {
    const headers = {
        ...shared_1.axios.defaults.headers.common,
        'X-Idempotency-Key': idempotencyKey,
    };
    const newPayload = {
        data: {
            type: enums_1.RequestType.PAYMENTS,
            attributes: {
                paymentFlowType: payment_1.PaymentFlowType.TERMINAL,
                orderId: offlinePaymentId,
                requestedAmount: transactionAmount,
                terminalId: deviceId,
                employeeId: currentShiftId,
                customerId,
            },
        },
    };
    const res = await shared_1.axios.post(shared_1.BLAZEPAY_API_URL + `/api/v1/merchants/${merchantId}/providers/${providerName}/payments`, newPayload, { headers });
    return res.data;
};
exports.processSaleTransaction = processSaleTransaction;
/**
 *
 * @description Idempotency-Key should be unique for each request and store it in the database for each transaction
 * @returns
 */
const processRefundTransaction = async ({ idempotencyKey, merchantId, providerName, payload: { deviceId, transactionAmount, currentShiftId, reason, paymentId }, }) => {
    const headers = {
        ...shared_1.axios.defaults.headers.common,
        'X-Idempotency-Key': idempotencyKey,
    };
    const newPayload = {
        data: {
            type: enums_1.RequestType.REFUNDS,
            attributes: {
                requestedAmount: transactionAmount,
                refundType: refund_1.RefundType.REFUND,
                reason,
                paymentId,
                terminalId: deviceId,
                employeeId: currentShiftId,
            },
        },
    };
    const res = await shared_1.axios.post(shared_1.BLAZEPAY_API_URL + `/api/v1/merchants/${merchantId}/providers/${providerName}/refunds`, newPayload, { headers });
    return res.data;
};
exports.processRefundTransaction = processRefundTransaction;
const getSaleTransaction = async ({ merchantId, providerName, transactionId, }) => {
    const res = await shared_1.axios.get(shared_1.BLAZEPAY_API_URL +
        `/api/v1/merchants/${merchantId}/providers/${providerName}/payments/${transactionId}`);
    return res.data;
};
exports.getSaleTransaction = getSaleTransaction;
const getRefundTransactions = async ({ merchantId, providerName, filter, }) => {
    const params = filter && convertFilterToParams(filter);
    const res = await shared_1.axios.get(shared_1.BLAZEPAY_API_URL + `/api/v1/merchants/${merchantId}/providers/${providerName}/refunds`, {
        params,
    });
    return res.data;
};
exports.getRefundTransactions = getRefundTransactions;
//# sourceMappingURL=BlazepayAPI.js.map